import { render } from "./basic-accordion.vue?vue&type=template&id=af687bb2"
import script from "./basic-accordion.vue?vue&type=script&lang=js"
export * from "./basic-accordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__